import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const TryIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"try"} ref={ref}/>
});

TryIcon.displayName = "TryIcon";
